import { Domicile } from '@services/appsync/types';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useCreateAccountViewModel } from '../models/CreateAccountViewModel';
import { CreateAccountForm, CreateAccountState } from '../types';
import { AccountReview } from '../views/AccountReview';
import { Address } from '../views/Address';
import { Citizenship } from '../views/Citizenship';

type CreateAccountControllerProps = {
  page: CreateAccountState;
};

export const CreateAccountController: React.FC<CreateAccountControllerProps> = ({ page }) => {
  const viewModel = useCreateAccountViewModel();

  useEffect(() => {
    viewModel.setCreateAccountState(page);
  }, [page]);

  const form = useForm<CreateAccountForm>({ defaultValues: { citizenship: Domicile.USC }, mode: 'onChange' });

  let content;
  switch (viewModel.state) {
    case 'CITIZENSHIP':
      content = <Citizenship form={form} />;
      break;
    case 'ADDRESS':
      content = <Address form={form} />;
      break;
    case 'REVIEW':
      content = <AccountReview form={form} />;
      break;
  }
  return content;
};
